import React from 'react'
import { Loader } from '../../design-system'

// LoadingSpinner , app-wide loader. Delegates to the design-system <Loader>
// so there's exactly ONE animated DKG logo across the entire codebase.
// Preserves the legacy absolute-centered positioning that callers depend on:
// the wrapping span sits at `top/right/bottom/left: 0; margin: auto`, which
// centers inside the nearest positioned ancestor (or in the viewport when
// none).
const Loading = React.memo(function Loading() {
  return (
    <span
      aria-label="Wird geladen"
      className="z-10"
      style={{
        position: 'absolute',
        top: 0, right: 0, bottom: 0, left: 0,
        margin: 'auto',
        width: 'fit-content',
        height: 'fit-content',
        pointerEvents: 'none',
      }}
    >
      <Loader size={58}/>
    </span>
  )
})

export default Loading
